webpackJsonp([32],{

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(653)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(733),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.04b8d3c.png";

/***/ }),

/***/ 537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showFeedbackBtn: false
    };
  },


  computed: {
    toastShow: function toastShow() {
      return this.$store.getters.toastr;
    },
    logoProvider: function logoProvider() {
      return this.$store.getters.logoProvider;
    },
    loadingLogo: function loadingLogo() {
      return this.$store.getters.loadingLogo;
    },
    anyLoading: function anyLoading() {
      return this.$store.getters.loadingLogo || this.$store.getters.loadingEmail || this.$store.getters.loadingOrderRequest || this.$store.getters.loadingCheckout;
    }
  }
});

/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, "#app{background:#f3f3f3}.info-hotsite{color:#999;font-size:16px}.btn-hotsite-gray{border-radius:10px;color:#999!important;background-color:#e7e7e7!important;text-transform:none;margin-top:10px}.btn-hotsite{border-radius:10px;color:#fff!important;background-color:#009865!important}.logo-header{position:relative;width:100%;text-align:center;padding:20px;min-height:145.63px;background-color:#fff}.administrator,.logo-header img{max-width:200px;max-height:100px}.plus{width:20px;position:relative;top:-50px}.main-body{height:100%;background-color:#f3f3f3}.hotsite-body{background-color:#f3f3f3;padding-top:50px}.body{background:red}.custom-loader{-webkit-animation:loader 1s infinite;animation:loader 1s infinite;display:-webkit-box;display:-ms-flexbox;display:flex}.box-email{background:#fff;width:320px;margin:auto;padding:20px;margin-top:20px;border-radius:20px}@-webkit-keyframes loader{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes loader{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.progrees-line{position:absolute;bottom:0;margin:0;left:0}.titulo-logo{width:300px;margin:auto}.titulo-logo h4{width:calc(100% - 80px);color:#a2a2a2;float:left;position:relative;top:11px;font-size:39px;left:2px}.titulo-logo img{width:80px;height:80px;float:left}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/hotsite/index.vue"],"names":[],"mappings":"AACA,KACE,kBAAoB,CACrB,AACD,cACE,WAAe,AACf,cAAgB,CACjB,AASD,kBACE,mBAAoB,AACpB,qBAA0B,AAC1B,mCAAqC,AACrC,oBAAqB,AACrB,eAAiB,CAClB,AACD,aACE,mBAAoB,AACpB,qBAAuB,AACvB,kCAAqC,CACtC,AACD,aACI,kBAAmB,AACnB,WAAY,AACZ,kBAAmB,AACnB,aAAc,AACd,oBAAqB,AACrB,qBAAuB,CAC1B,AACD,gCACE,gBAAiB,AACjB,gBAAkB,CACnB,AACD,MACE,WAAY,AACZ,kBAAmB,AACnB,SAAW,CACZ,AACD,WACE,YAAa,AACb,wBAA0B,CAC3B,AACD,cACE,yBAA0B,AAC1B,gBAAkB,CACnB,AACD,MACE,cAAgB,CACjB,AACD,eACE,qCAAsC,AAC9B,6BAA8B,AACtC,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,WACE,gBAAiB,AACjB,YAAa,AACb,YAAa,AACb,aAAc,AACd,gBAAiB,AACjB,kBAAoB,CACrB,AACD,0BACA,GACI,4BAA6B,AACrB,mBAAqB,CAChC,AACD,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,kBACA,GACI,4BAA6B,AACrB,mBAAqB,CAChC,AACD,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,eACE,kBAAmB,AACnB,SAAS,AACT,SAAU,AACV,MAAQ,CACT,AACD,aACE,YAAa,AACb,WAAa,CACd,AACD,gBACE,wBAAyB,AACzB,cAAe,AACf,WAAY,AACZ,kBAAmB,AACnB,SAAU,AACV,eAAgB,AAChB,QAAU,CACX,AACD,iBACE,WAAY,AACZ,YAAa,AACb,UAAY,CACb","file":"index.vue","sourcesContent":["\n#app{\n  background: #f3f3f3;\n}\n.info-hotsite{\n  color: #999999;\n  font-size: 16px;\n}\n.box-email{\n  background: #fff;\n  width: 320px;\n  margin: auto;\n  padding: 20px;\n  margin-top: 20px;\n  border-radius: 20px;\n}\n.btn-hotsite-gray{\n  border-radius: 10px;\n  color: #999999 !important;\n  background-color: #e7e7e7 !important;\n  text-transform: none;\n  margin-top: 10px;\n}\n.btn-hotsite {\n  border-radius: 10px;\n  color: #fff !important;\n  background-color: #009865 !important;\n}\n.logo-header{\n    position: relative;\n    width: 100%;\n    text-align: center;\n    padding: 20px;\n    min-height: 145.63px;\n    background-color: #fff;\n}\n.logo-header img, .administrator{\n  max-width: 200px;\n  max-height: 100px;\n}\n.plus{\n  width: 20px;\n  position: relative;\n  top: -50px;\n}\n.main-body{\n  height: 100%;\n  background-color: #f3f3f3;\n}\n.hotsite-body{\n  background-color: #f3f3f3;\n  padding-top: 50px;\n}\n.body{\n  background: red;\n}\n.custom-loader {\n  -webkit-animation: loader 1s infinite;\n          animation: loader 1s infinite;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.box-email{\n  background: #fff;\n  width: 320px;\n  margin: auto;\n  padding: 20px;\n  margin-top: 20px;\n  border-radius: 20px;\n}\n@-webkit-keyframes loader {\nfrom {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n}\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes loader {\nfrom {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n}\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n.progrees-line{\n  position: absolute;\n  bottom:0;\n  margin: 0;\n  left: 0;\n}\n.titulo-logo{\n  width: 300px;\n  margin: auto;\n}\n.titulo-logo h4 {\n  width: calc(100% - 80px);\n  color: #a2a2a2;\n  float: left;\n  position: relative;\n  top: 11px;\n  font-size: 39px;\n  left: 2px;\n}\n.titulo-logo img {\n  width: 80px;\n  height: 80px;\n  float: left;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(606);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("6301f031", content, true, {});

/***/ }),

/***/ 733:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#f3f3f3",
      "height": "100%",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "logo-header"
  }, [(_vm.logoProvider === '') ? _c('v-slide-x-transition', {
    staticClass: "hotsite-body",
    attrs: {
      "mode": "out-in"
    }
  }, [_c('div', {
    staticClass: "titulo-logo mb-4 float-l"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(404),
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("CondoPlaza")])])]) : _c('v-slide-x-transition', {
    staticClass: "hotsite-body",
    attrs: {
      "mode": "out-in"
    }
  }, [_c('img', {
    key: _vm.logoProvider,
    attrs: {
      "src": _vm.logoProvider,
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.anyLoading),
      expression: "anyLoading"
    }],
    staticClass: "progrees-line",
    attrs: {
      "indeterminate": true,
      "height": "2",
      "color": "red",
      "background-color": "white"
    }
  })], 1), _vm._v(" "), _c('v-slide-x-transition', {
    staticClass: "hotsite-body",
    attrs: {
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.toastShow.time,
      "color": _vm.toastShow.color,
      "top": true,
      "right": true
    },
    model: {
      value: (_vm.toastShow.visibility),
      callback: function($$v) {
        _vm.$set(_vm.toastShow, "visibility", $$v)
      },
      expression: "toastShow.visibility"
    }
  }, [_vm._v("\n   " + _vm._s(_vm.toastShow.text) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/32.15f132f2c58448cbed06.js